import FilterSelect from "./FilterSelect";

export default function FilterSortGroup({
  id,
  sortBy,
  sortOrder,
  onSortByChange,
  onSortOrderChange,
  sortOptions = [],
}) {
  return (
    <div className="space-y-1.5 rounded border border-gray-300 bg-white p-2">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-800">Sort</p>
      <div>
        <label htmlFor={`${id}-sort-by`} className="mb-0.5 block text-[10px] font-medium text-gray-800">
          Sort by
        </label>
        <FilterSelect
          id={`${id}-sort-by`}
          value={sortBy}
          onChange={onSortByChange}
          placeholder={null}
          options={sortOptions}
        />
      </div>
      <div>
        <label htmlFor={`${id}-sort-order`} className="mb-0.5 block text-[10px] font-medium text-gray-800">
          Direction
        </label>
        <FilterSelect
          id={`${id}-sort-order`}
          value={sortOrder}
          onChange={onSortOrderChange}
          placeholder={null}
          options={[
            { value: "asc", label: "Ascending" },
            { value: "desc", label: "Descending" },
          ]}
        />
      </div>
    </div>
  );
}
